module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAPdJREFUWEftldENwjAMRK8b0A0YATagm7AZK8EEMAJsgCw1KBgn5zRU/XGlfl1iv1xie8DG37BxfgRAOBAOLHXgBOAx/1YlM/2zZwnAGcAFwBPAaGRn+teWVoAUXILcABwUANN/eFsAdHCxWVxIH9PNpusFYMGZXuz4HoA8+AuAnPxaOLmlV8cNA1g1uZDVAPYA7jO+dTKmuwatF0Ae26SszwEsvRtAAuRXYCVhOoVgb2B1CA+AhpAKkOso9QBL7ypDq9H8DcLrQAniWGnFAqn1rlasIaQ0d5VhVNK7hlHazMYt07vGMS2tlgWtb6AltmttAIQD4cAb1NNUIX7FJv8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page_previous_icon.png
// module id = Bzq/
// module chunks = 3